<div class="ant-table-content">
  <table ui-table-content [contentTemplate]="contentTemplate" [tableLayout]="tableLayout" [listOfColWidth]="listOfColWidth" [theadTemplate]="theadTemplate"></table>
</div>
